import { useEffect, useState } from 'react';

import { STALE_AFTER_MS } from './storeDashboardData';

/**
 * `{ isStale, ageMinutes }` for a data timestamp. Arms one timeout at updatedAt + 5 min and
 * then a 60 s tick for the "N min" label, so only stale widgets ever tick.
 */
export function useStale(updatedAt) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!updatedAt) return undefined;
    const staleAt = updatedAt + STALE_AFTER_MS;
    let interval = null;
    const timeout = setTimeout(() => {
      setNow(Date.now());
      interval = setInterval(() => setNow(Date.now()), 60000);
    }, Math.max(0, staleAt - Date.now()));
    setNow(Date.now());
    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, [updatedAt]);

  if (!updatedAt) return { isStale: false, ageMinutes: 0 };
  const age = now - updatedAt;
  return { isStale: age >= STALE_AFTER_MS, ageMinutes: Math.floor(age / 60000) };
}
